import {
	FormImageUploaderContext,
	IFormImageUploaderContext,
} from '../../formImageUploaderState/formImageUploaderContext';
import React, { useContext, useCallback, useMemo } from 'react';
import ModalSentError from 'components/ModalWindows/ModalSentError';
import classNames from 'classnames';
import style from './ErrorModals.module.scss';

interface IErrorModals {
	maxFileSizeMB?: number;
}

const ErrorModals: React.FC<IErrorModals> = ({ maxFileSizeMB }) => {
	const { changeTypeOfErrorModalWindow, typeOfErrorModalWindow } =
		useContext<IFormImageUploaderContext>(FormImageUploaderContext);
	const containerClasses = classNames(style.container, { [style.visible]: typeOfErrorModalWindow });

	const maxFileSize = useMemo(
		() => ({
			size: `${maxFileSizeMB}MB`,
		}),
		[maxFileSizeMB],
	);
	const formats = useMemo(() => ({ formats: '.jpeg, .jpg, .png' }), []);

	const handleCloseModal = useCallback(() => {
		changeTypeOfErrorModalWindow(null);
	}, []);

	return (
		<div className={containerClasses} data-test="ModalWindows">
			<ModalSentError
				onConsentEvent={handleCloseModal}
				isVisible={typeOfErrorModalWindow === 'fileSizeExceeded'}
				description="fileSizeExceeded"
				translationOptions={maxFileSize}
			/>
			<ModalSentError
				onConsentEvent={handleCloseModal}
				isVisible={typeOfErrorModalWindow === 'fileUploadError'}
				description="fileUploadError"
			/>
			<ModalSentError
				onConsentEvent={handleCloseModal}
				isVisible={typeOfErrorModalWindow === 'invalidFileFormat'}
				description="invalidFileFormatPhoto"
				translationOptions={formats}
			/>
		</div>
	);
};

export default ErrorModals;
